<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2298_8220)">
<rect x="4.85" y="3.85" width="28.3" height="22.3" rx="1.65" stroke="currentColor" stroke-width="1.7"/>
<path d="M15.4026 11.8136C15.409 11.0394 15.4123 10.6522 15.6647 10.5102C15.9171 10.3682 16.2497 10.5665 16.9147 10.9631L22.2371 14.1368C22.8826 14.5217 23.2054 14.7142 23.2047 14.9989C23.2041 15.2836 22.8805 15.4747 22.2333 15.8568L16.858 19.0305C16.1829 19.4292 15.8453 19.6285 15.5926 19.4828C15.3398 19.3371 15.3431 18.9451 15.3496 18.1611L15.4026 11.8136Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2298_8220">
<rect width="38" height="30" fill="white"/>
</clipPath>
</defs>
</svg>
